import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'firstName',
    label: 'User Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'lastName',
    label: 'Last Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'email',
    label: 'User Email',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'role',
    path: [],
    label: 'User Role',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    key: 'role',
    value: [],
    options: 'userRoleOptions',
  },
  {
    name: 'status',
    path: [],
    label: 'User Status',
    matching: FilterMatchingType.ARRAY_INCLUDES_PROPERTY,
    key: 'status',
    value: [],
    options: 'userStatusOptions',
  },
];